import React, { FunctionComponent } from "react";
import { Placement } from "react-bootstrap/cjs/types";
import ReanalyzeFormInput, {
  LAYOUT_TYPE
} from "../reanalyze-form-input/ReanalyzeFormInput";
import ReanalyzeCardContainer from "../reanalyze-card-container/ReanalyzeCardContainer";

type ReanalyzeCrawlerInputProps = {
  disabled?: boolean;
  label: string;
  labelIcon?: string;
  onToggle: () => void;
  selected: boolean;
  tooltipMessage?: string;
  tooltipPlacement?: Placement;
};

const ReanalyzeCrawlerInput: FunctionComponent<ReanalyzeCrawlerInputProps> = ({
  disabled,
  label,
  labelIcon = "",
  onToggle,
  selected,
  tooltipMessage,
  tooltipPlacement
}) => (
  <ReanalyzeCardContainer
    disabled={disabled}
    selected={selected}
    layout={LAYOUT_TYPE.ROW}
    onClick={() => {
      if (disabled) {
        return;
      }
      onToggle();
    }}
    classNameOuterContainer={"mb-10"}
  >
    <ReanalyzeFormInput
      name="scraper"
      label={label}
      labelIcon={labelIcon}
      labelIconSize={18}
      disabled={disabled}
      layout={LAYOUT_TYPE.ROW}
      checked={selected}
      tooltipMessage={tooltipMessage}
      tooltipPlacement={tooltipPlacement}
    />
  </ReanalyzeCardContainer>
);

export default ReanalyzeCrawlerInput;
